import { useLocation } from 'react-router-dom'

import { DeleteParticipantsModal } from 'modules/trainings/components/Revamp/TrainingsDetail/TrainingEmployeesDataTable/DeleteParticipantsModal'
import { BulkSelection } from 'modules/trainings/components/Revamp/TrainingsDetail/ParticipantsOneDataTable/hooks/useBulkActionsConfig'

interface LocationState {
  selection?: BulkSelection
}

const isLocationState = (state: unknown): state is LocationState => {
  return (
    typeof state === 'object' &&
    state !== null &&
    ('selection' in state || Object.keys(state).length === 0)
  )
}

const DeleteParticipants = () => {
  const location = useLocation()

  if (!isLocationState(location.state) || !location.state.selection) {
    return <DeleteParticipantsModal selection={{ type: 'manual', ids: [] }} />
  }

  return <DeleteParticipantsModal selection={location.state.selection} />
}

export default DeleteParticipants
